import { types } from 'mobx-state-tree';

import { BaseDocument } from '../../../common/stable';

import Journey from './Journey';


const MortgageDocument = BaseDocument
    .named('MortgageDocument')
    .props({
        schemaVersion: types.snapshotProcessor(types.optional(types.integer, 4), {
            preProcessor(schemaVersion) {
                if (typeof schemaVersion === 'string') {
                    const parsedVersion = parseInt(schemaVersion);
    
                    return Number.isNaN(parsedVersion)
                        ? schemaVersion // failed to parse, use as-is
                        : parsedVersion;
                }
    
                return schemaVersion;
            },
        }),
        journey: Journey,
    });

export default MortgageDocument;
